module.exports = __webpack_public_path__ + "static/media/floor.b88f9aa9.svg";